import { useEffect, useRef, useState } from "react";
import { RMR_INFO } from "../../constants/contact-info";
import { getDayByNumber, getScheduleStatus } from "../../utils/date-utils";

export function RMRCard({ 
    onClose,
    onAnimationEnd,
    onFirstRender: onRender
 }: { 
    onClose?: () => void; 
    onAnimationEnd?: () => void; 
    onFirstRender?: () => void; 
}) {
    const [scheduleIsOpen, setScheduleIsOpen] = useState<boolean>(false);
    const [isVisible, setIsVisible] = useState(false);
    const cardRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = cardRef.current;
        if(!el) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if(entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.3 }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if(isVisible) {
            onRender?.();
        }
    }, [isVisible]);

    const status = getScheduleStatus(RMR_INFO.workSchedule);

    return (
        <>
            <div 
                onAnimationEnd={(e) => {
                    if(e.target !== e.currentTarget) return;

                    onAnimationEnd?.();
                }} 
                className="card popup-animated"
                ref={cardRef}
            >
                <div className="card__accordion--scrollable">
                    <div className="card-top">
                        <div className="card-top__left">
                            <img
                                className="rmr-logo"
                                src={process.env.PUBLIC_URL + "/rmr_logo.svg"}
                                alt="Логотип работа молодёжи Росиии"
                            />
                        </div>
                        <button
                            type="button"
                            className="card-close__btn"
                            onClick={onClose}
                        >
                            <ion-icon name="close" />
                        </button>
                    </div>
                    <div className="card-bottom without-padding">
                        <div className="card-info info-separator">
                            <span>Адрес</span>
                            <span>{RMR_INFO.address}</span>
                        </div>
                        <div className="card-info info-separator">
                            <span>Контакты</span>
                            <span>{RMR_INFO.phone}</span>
                        </div>
                        <div className="card-info">
                            <div className="card-info">
                                <span>Время работы</span>
                            </div>
                            <div className="card-info__bottom">
                                <div className={`${status.isOpen ? '' : 'text--red'}`}>{status.label}</div>
                                <button
                                    type="button"
                                    className="card-info--with-btn"
                                    onClick={() => setScheduleIsOpen(!scheduleIsOpen)}
                                >
                                    <div className="card-info--with-btn">
                                        <span>График</span>
                                        <ion-icon 
                                            className={`card__accordion--dropdown__chevron ${scheduleIsOpen ? 'open' : ''}`} 
                                            name="chevron-forward"
                                        />
                                    </div>
                                </button>
                            </div>

                            <div className={`card__accordion--dropdown  ${scheduleIsOpen ? "" : "hidden"}`}>
                                {RMR_INFO.workSchedule.map((ws, i) => (
                                    <div className="card-info__bottom" key={`schedule-item-${i}`}>
                                        <div className="card-info--rmr">
                                            {i > 4 ? (
                                                <span>
                                                    {getDayByNumber(i)}
                                                </span>
                                            ): (
                                                getDayByNumber(i)
                                            )}
                                        </div>
                                        {i > 4 ? (
                                            <span className="text--red">
                                                {ws}
                                            </span>
                                        ): (
                                            <span>
                                                {ws}
                                            </span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};